export default "__VITE_ASSET__cc0cf5cc__"